import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';
import { CapellaNotification, NotificationUrlScope } from 'types/notifications-slice';

export const notificationsSliceName = 'notifications';

const getInitialState = () => ({
  notificationsByUrl: {} as { [urlScope: string]: CapellaNotification[] },
});

export const notificationsSlice = createSlice({
  name: notificationsSliceName,
  initialState: getInitialState(),
  reducers: {
    createNotification(
      state,
      { payload: { notification, urlScope } }: PayloadAction<{ notification: CapellaNotification; urlScope: NotificationUrlScope }>
    ) {
      if (!(urlScope in state.notificationsByUrl)) {
        state.notificationsByUrl[urlScope] = [];
      }

      state.notificationsByUrl[urlScope].push(notification);
    },

    clearNotifications(state, { payload: urlScope }: PayloadAction<NotificationUrlScope>) {
      state.notificationsByUrl[urlScope] = [];
    },

    clearNextNotification(state, { payload: urlScope }: PayloadAction<NotificationUrlScope>) {
      state.notificationsByUrl[urlScope] = state.notificationsByUrl[urlScope].filter(
        (notif) => notif.message !== state.notificationsByUrl[urlScope].at(-1)?.message
      );
    },

    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export type NotificationsSlicePayload = ReturnType<typeof notificationsSlice.getInitialState>;
export const { createNotification, clearNotifications, reset, clearNextNotification } = notificationsSlice.actions;

export const selectNotificationsByUrl = (state: RootState) => {
  return state[notificationsSliceName].notificationsByUrl;
};
